
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("b0ztm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "GlobalAutomationApp", () => $0caf38752f024d14$export$7467b029cb2c9926);
$parcel$export(module.exports, "default", () => $0caf38752f024d14$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $drk9v = parcelRequire("drk9v");

var $9NiTW = parcelRequire("9NiTW");

var $4dRjY = parcelRequire("4dRjY");
function $0caf38752f024d14$export$7467b029cb2c9926(_props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drk9v.default), null)));
}
var $0caf38752f024d14$export$2e2bcd8739ae039 = $0caf38752f024d14$export$7467b029cb2c9926;

});
parcelRegister("drk9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c7e8d35da359c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");

var $9FUIO = parcelRequire("9FUIO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dZw8H = parcelRequire("dZw8H");

var $2tT7R = parcelRequire("2tT7R");

var $9OXo1 = parcelRequire("9OXo1");

var $7FRCI = parcelRequire("7FRCI");
const $c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME = 'automationManagerBootstrap.pack.js';
let $c8c7e8d35da359c5$var$isBootStrapBeenAppended = false;
const $c8c7e8d35da359c5$export$1d6aa6cfe656cb32 = (jiraEnvironment, isAutomationDevInstance)=>{
    if (isAutomationDevInstance) {
        if (jiraEnvironment === 'staging') return 'dev';
        if (jiraEnvironment === 'prod') return 'test';
    }
    return jiraEnvironment === 'staging' ? 'staging' : 'prod';
};
/**
 * https://developer.atlassian.com/platform/bifrost/config/custom-domain/#custom-domain:-stating-your-own-identity
 * For fedramp, we return **environment type** rather than the **environment** itself.
 * @param environment
 * @param isFedRampInstance
 * @returns
 */ const $c8c7e8d35da359c5$var$getBifrostEnvironment = (environment, isFedRampInstance = false)=>{
    let bifrostEnvironment;
    if (environment === 'staging') bifrostEnvironment = isFedRampInstance ? 'stg' : 'stg-east';
    else // it's empty for fedramp prod
    bifrostEnvironment = isFedRampInstance ? '' : 'prod-east';
    return bifrostEnvironment;
};
/**
 * Gets the correct Bifrost url suffix based on the perimeter
 */ const $c8c7e8d35da359c5$var$getBifrostUrlSuffix = (isFedRampInstance)=>isFedRampInstance ? 'frontend.cdn.atlassian-us-gov-mod.com' : 'frontend.public.atl-paas.net';
const $c8c7e8d35da359c5$var$getBifrostBaseUrl = (env, perimeter)=>{
    const isFedRampInstance = perimeter === 'FEDRAMP';
    const bifrostUrlPrefix = 'https://automation-frontend';
    const bifrostEnvironment = $c8c7e8d35da359c5$var$getBifrostEnvironment(env, isFedRampInstance);
    const bifrostUrlSuffix = $c8c7e8d35da359c5$var$getBifrostUrlSuffix(isFedRampInstance);
    return [
        bifrostUrlPrefix,
        bifrostEnvironment,
        bifrostUrlSuffix
    ]// remove empty strings
    .filter((str)=>str).join('.');
};
const $c8c7e8d35da359c5$export$4bfd551f705b2cb = (env, perimeter)=>{
    // Local dev source
    if (env === 'dev') return `https://localhost:8082/${$c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME}`;
    return `${$c8c7e8d35da359c5$var$getBifrostBaseUrl(env, perimeter)}/${$c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME}`;
};
const $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE = 'Sorry, something went wrong loading Automation. Please try again.';
const $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE = 'Are you running devWatch?';
const $c8c7e8d35da359c5$var$determineAutomationPerimeter = ()=>{
    if ((0, $c04PQ.isFedRamp)()) return 'FEDRAMP';
    return 'COMMERCIAL';
};
const $c8c7e8d35da359c5$var$AutomationAppComponent = ({ container: container })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const jiraEnvironment = (0, $2tT7R.useEnvironment)();
    const automationEnvironment = $c8c7e8d35da359c5$export$1d6aa6cfe656cb32(jiraEnvironment, (0, $4R6GH.fg)('automation-dev-helper'));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [bootStrapError, setBootStrapError] = (0, $5uXOq.useState)(null);
    const perimeter = (0, $5uXOq.useMemo)(()=>$c8c7e8d35da359c5$var$determineAutomationPerimeter(), []);
    (0, $5uXOq.useEffect)(()=>{
        if (performance) performance.mark('automation-host-product-start');
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!$c8c7e8d35da359c5$var$isBootStrapBeenAppended) {
            // eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
            const script = document.createElement('script');
            const src = $c8c7e8d35da359c5$export$4bfd551f705b2cb(automationEnvironment, perimeter);
            const startTime = performance.now();
            script.src = src;
            script.async = true;
            script.onload = ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'loaded'
                }), 'automationBootstrapFile loaded', {
                    duration: duration,
                    automationEnvironment: automationEnvironment,
                    isUsingVersionedAssets: true
                });
            };
            script.onerror = async ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'failed'
                }), 'automationBootstrapFile failed', {
                    duration: duration,
                    automationEnvironment: automationEnvironment,
                    isUsingVersionedAssets: true
                });
                setBootStrapError(automationEnvironment === 'dev' ? $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE : $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE);
                throw new Error(`Failed to load automation boostrap for env ${automationEnvironment}, src was '${src}'`);
            };
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.appendChild(script);
            $c8c7e8d35da359c5$var$isBootStrapBeenAppended = true;
        }
    }, [
        automationEnvironment,
        createAnalyticsEvent,
        perimeter
    ]);
    // Lifecycle events automation application can respond to start the application, and destroy it.
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.postMessage('automation-container-mounted');
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.postMessage('automation-container-unmounted');
        };
    }, []);
    if (bootStrapError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FRCI.default), {
        title: "Failed to load Automation",
        description: bootStrapError
    });
    const context = {
        activationId: activationId,
        cloudId: cloudId,
        scopeId: container?.id || 'GLOBAL',
        scopeKey: container?.key,
        scopeType: container?.type,
        productType: 'jira',
        env: automationEnvironment,
        staticPrefix: $c8c7e8d35da359c5$var$getBifrostBaseUrl(automationEnvironment, perimeter),
        perimeter: perimeter,
        isUsingVersionedAssets: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FUIO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "automation-container",
        "data-context": JSON.stringify(context),
        "data-testid": "automation.automation-app-container"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
const $c8c7e8d35da359c5$var$AutomationApp = ({ container: container })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8c7e8d35da359c5$var$AutomationAppComponent, {
        container: container
    });
var $c8c7e8d35da359c5$export$2e2bcd8739ae039 = $c8c7e8d35da359c5$var$AutomationApp;

});
parcelRegister("9FUIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1259b4dcb355d8f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener = (0, $kxZPA.lazy)(()=>(parcelRequire("2LsZY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $1259b4dcb355d8f8$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener, null)));
var $1259b4dcb355d8f8$export$2e2bcd8739ae039 = $1259b4dcb355d8f8$export$9b28d5c0f56030a7;

});
parcelRegister("2LsZY", function(module, exports) {

let $2036770b6e46ea68$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2036770b6e46ea68$var$load("1UZFB").then(()=>parcelRequire('LS48m'));

});


parcelRegister("7FRCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e338e454c92b953e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");
const $e338e454c92b953e$var$BootstrapPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e338e454c92b953e$var$pageContainerStyles,
        testId: "automation.automation-platform-bootstrap-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e338e454c92b953e$var$contentContainerStyles
    }, props.children));
const $e338e454c92b953e$var$BootstrapError = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e338e454c92b953e$var$BootstrapPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        title: props.title
    }, props.description));
var $e338e454c92b953e$export$2e2bcd8739ae039 = $e338e454c92b953e$var$BootstrapError;
const $e338e454c92b953e$var$pageContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh'
});
const $e338e454c92b953e$var$contentContainerStyles = (0, $8CUq3.xcss)({
    justifyContent: 'center',
    width: '500px'
});

});


parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});



//# sourceMappingURL=async-global-automation.442420b2.js.map
